var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 25,
    viewBox: "0 0 170 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_1295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24.8991L9.68719 0L19.3744 24.8991H16.2294C16.2294 24.8991 14.4341 21.8592 10.5071 19.3155C6.58005 16.776 3.27111 16.5069 3.27111 16.5069L2.23259 14.6359C2.23259 14.6359 4.65439 14.3878 8.12731 15.4726C11.6002 16.5531 13.7109 18.2139 13.7109 18.2139L9.69559 7.52607L3.19963 24.8991H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2333 0.0126953V24.8992H31.3782V15.7838L34.6283 12.5379L42.8229 24.8992H46.5775L36.8399 10.0783L46.4556 0.0126953H42.0367L31.3614 11.2261L31.3698 0.0126953H28.2333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6054 21.2456H21.9222V24.9035H25.6054V21.2456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6951 21.2456H49.012V24.9035H52.6951V21.2456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8336 6.29834H61.3858V22.3596H67.3898V24.8781H58.8336V6.29834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4857 6.29834H69.963V24.8781H72.4857V6.29834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.654 6.06299H127.132V24.71H129.654V6.06299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9636 6.27734H98.5158V13.3199H107.408V6.27734H109.986V24.8781H107.366V15.9141H98.5578V24.8781H95.9636V6.27734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.836 6.27734H124.323V8.80846H119.921V24.8781H117.323V8.80846H112.836",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6449 8.50975C90.6449 8.50975 87.1216 4.49865 80.8232 7.05078C76.7196 8.71577 75.3826 12.6554 75.3826 15.5859C75.3826 19.4877 78.1786 24.7013 84.8385 24.7013C88.3282 24.7013 91.0948 22.6411 92.4571 20.3791C94.0296 17.7639 93.8193 15.485 93.8193 15.485H85.8182L87.3066 17.9951H90.6912C90.6912 17.9951 89.392 22.208 84.6073 22.208C80.0706 22.208 77.9473 18.1423 77.9473 15.7205C77.9473 12.996 79.5619 9.12361 84.2877 8.76202C87.7354 8.76202 89.0346 10.5069 89.0346 10.5069L90.6533 8.50554L90.6449 8.50975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.473 8.50584C166.473 8.50584 162.95 4.49474 156.652 7.04688C152.548 8.71186 151.211 12.6557 151.211 15.582C151.211 19.4838 154.007 24.6974 160.667 24.6974C164.157 24.6974 166.923 22.6372 168.285 20.3752C169.862 17.76 169.648 15.4811 169.648 15.4811H161.647L163.135 17.9912H166.52C166.52 17.9912 165.22 22.2041 160.436 22.2041C155.899 22.2041 153.771 18.1426 153.771 15.7166C153.771 12.9921 155.39 9.1197 160.112 8.75811C163.56 8.75811 164.859 10.503 164.859 10.503L166.478 8.50164L166.473 8.50584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.514 24.8782V6.06299L145.707 18.6387V6.1681H148.327V25.0001L136.146 12.6178L136.159 24.8782H133.514Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_1295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 169.656,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.c690957535256ca25538f4f69f87e091.svg";
export { ForwardRef as ReactComponent };